<template>
  <v-card>
    <v-card-title>Certifications</v-card-title>

    <ListCard :items='certifications' />
  </v-card>
</template>

<script>
import { mdiWeb } from '@mdi/js'
import ListCard from '../ListCard'

export default {
  name: 'Certifications',
  components:{
    ListCard
  },
  data(){
    return {
      certifications: [
        {
          src: '/img/certifications/IBM_data_analysis_python.png',
          alt: 'IBM Data Analysis with Python',
          name: 'IBM Data Analysis with Python',
          summary: 'An online course offered by IBM through Coursera.',
          dialog: false,
          details: false,
          links: [
            {
              icon: mdiWeb,
              href: 'https://coursera.org/share/d74489d7e8d841c4e17e5b8c8e1cf6c6',
              color: 'black'
            }
          ]
        },
        // {
        //   src: '/img/certifications/google.png',
        //   alt: 'Foundations: Data, Data, Everywhere',
        //   name: 'Foundations: Data, Data, Everywhere',
        //   summary: 'An online course offered by Google through Coursera.',
        //   dialog: false,
        //   details: false,
        //   links: [
        //     {
        //       icon: mdiWeb,
        //       href: 'https://coursera.org/share/406585ce97dbb17f542764f4f2002cb5',
        //       color: 'black'
        //     }
        //   ]
        // },
        // {
        //   src: '/img/certifications/google.png',
        //   alt: 'Ask Questions to Make Data-Driven Decisions',
        //   name: 'Ask Questions to Make Data-Driven Decisions',
        //   summary: 'An online course offered by Google through Coursera.',
        //   dialog: false,
        //   details: false,
        //   links: [
        //     {
        //       icon: mdiWeb,
        //       href: 'https://coursera.org/share/f43cb522532b716ac7db8fab1f590d67',
        //       color: 'black'
        //     }
        //   ]
        // },
        // {
        //   src: '/img/certifications/google.png',
        //   alt: 'Prepare Data for Exploration',
        //   name: 'Prepare Data for Exploration',
        //   summary: 'An online course offered by Google through Coursera.',
        //   dialog: false,
        //   details: false,
        //   links: [
        //     {
        //       icon: mdiWeb,
        //       href: 'https://coursera.org/share/8ffc6d7508fc274d3528815a37362ae6',
        //       color: 'black'
        //     }
        //   ]
        // },
      ],
    }
  }
}
</script>

<style>

</style>